<script>
  import LegendItem from "./LegendItem.svelte";

  import { t } from "../../../../core";
</script>

<div class="schedule-specifications one-column">
  <LegendItem deadlinePattern withBorder>
    {t("Panel.Legend.Deadline")}
  </LegendItem>
</div>
<div class="schedule-specifications">
  <LegendItem color="#db8700">{t("Panel.Legend.CurrentWeek")}</LegendItem>
  <LegendItem color="#a7a7a7">{t("Panel.Legend.CurrentSchedule")}</LegendItem>
  <LegendItem color="#002c64">{t("Panel.Legend.NewSchedule")}</LegendItem>
  <LegendItem color="#a21000">{t("Panel.Legend.Delay")}</LegendItem>
  <LegendItem vacationPattern withBorder>
    {t("Panel.Legend.Vacation")}
  </LegendItem>
</div>

<style lang="scss">
  .schedule-specifications {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 26px;
    font-size: 13px;

    @include sm-down {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-row-gap: 8px;
      grid-column-gap: 10px;

      :global(.legend-item) {
        &:nth-child(2) {
          grid-column: 1;
        }

        &:nth-child(3) {
          grid-column: 2;
          grid-row: 1;
        }

        &:nth-child(4) {
          grid-column: 2;
          grid-row: 2;
        }

        &:nth-child(5) {
          grid-column: 2;
          grid-row: 3;
        }
      }
    }

    &.one-column {
      grid-template-columns: 1fr;

      @include sm-down {
        margin-bottom: 10px;
      }
    }
  }
</style>
